import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import ValidacaoConvidados from './pages/ValidacaoConvidados';
import ConfirmaCaptura from './pages/ConfirmaCaptura';
import CapturaDocumento from './pages/CapturaDocumento';
import ErroValidar from './pages/ErroValidar';
import ConfirmaValidacao from './pages/ConfirmaValidacao';


function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<ValidacaoConvidados />} />
        <Route path="/captura-documento/" element={<CapturaDocumento />} />
        <Route path="/confirma-documento" element={<ConfirmaCaptura />} />
        <Route path="/confirma-validacao" element={<ConfirmaValidacao />} />
        <Route path="/erro-validacao" element={<ErroValidar />} />
      </Routes>
    </Router>
  );
}

export default App;
